import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { BasicFormService } from './shared/basic-form.service';
import { MockDataService } from './shared/mock-data.service';
import { Logger } from '@app/core';
import { BaseControl, DynamicFormComponent, Custom, AccionModal } from '@app/shared';

const log = new Logger('ExampleForms');

@Component({
  selector: 'iw-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss'],
  providers: [MockDataService, BasicFormService]
})
export class FormsComponent implements OnInit {
  // Referencia al formulario dinámico
  @ViewChild(DynamicFormComponent) dfcRef: DynamicFormComponent;
  controls: BaseControl<any>[] = [];
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Contexto para el control personalizado
  ctxSelectTpl: Custom;
  // Lista de prueba
  list = ['Item # 1', 'alguna cosa', 'lista de elementos'];

  constructor(private bfs: BasicFormService, private mds: MockDataService) {}

  ngOnInit() {
    this.init();
  }

  /**
   * Realiza las consultas necesarias y genera el formulario.
   *
   * @memberof FormsComponent
   */
  async init() {
    // this.controls = this.getControlsFormBasic();
    // Países del mundo para ejemplo de Typeahead
    // const countries = await this.mds.getCountries();
    this.controls = this.getControlsFormBasic({
      dataTypeahead: [],
      ngSelectTpl: this.ngSelectTpl
    });
  }

  /**
   * Retorna los controles del formulario.
   *
   * @param {*} [objectModel]
   * @returns {BaseControl<any>[]}
   * @memberof FormsComponent
   */
  getControlsFormBasic(objectModel?: any): BaseControl<any>[] {
    return objectModel ? this.bfs.getFields(objectModel) : this.bfs.getFields();
  }

  /**
   * Evento que se ejecuta cuando el formulario es enviado.
   *
   * @param {*} data
   * @memberof FormsComponent
   */
  sended(data: any) {
    log.debug('Data: ', data);
  }

  /**
   * Controla los eventos de accion del seletor en modal
   *
   * @param {AccionModal} data
   * @memberof FormsComponent
   */
  actionSelectModal(data: AccionModal) {
    console.log(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/examples/forms/forms.component.ts